import { yupResolver } from "@hookform/resolvers/yup";
import { components } from "react-select";
import * as Yup from "yup";
export const sALFormInputArr = [
  {
    field: "cci",
    arr: [
      {
        title: "Company Name",
        field: "cciCompanyName",
        type: "text",
        className: "col-6",
      },
      {
        title: "Select One",
        field: "cciSelectOne",
        className: "col-12",
        type: "radio",
        options: [
          { title: "Broker", value: "broker" },
          { title: "Direct", value: "direct" },
          { title: "Other", value: "other" },
        ],
      },
      {
        title: "Address",
        field: "cciAddress",
        type: "textarea",
        className: "col-6",
      },
      {
        title: "SLS Account No. (Existing Clients)",
        field: "cciSlsAcountNo",
        type: "text",
        className: "col-12",
      },
      { title: "City", field: "cciCity", type: "text", className: "col-4" },
      { title: "State", field: "cciState", type: "text", className: "col-4" },
      { title: "Zip", field: "cciZip", type: "text", className: "col-4" },
      {
        title: "Contact Name",
        field: "cciCNContactName",
        type: "text",
        className: "col-6",
      },
      {
        title: "Additional Contact",
        field: "cciACAdditionalContact",
        type: "phoneNumber",
        className: "col-6",
      },
      {
        title: "Work Phone",
        field: "cciCNWorkPhone",
        type: "phoneNumber",
        className: "col-6",
      },
      {
        title: "Work Phone",
        field: "cciACWorkPhone",
        type: "phoneNumber",
        className: "col-6",
      },
      {
        title: "Cell Phone",
        field: "cciCNCellPhone",
        type: "phoneNumber",
        className: "col-6",
      },
      {
        title: "Cell Phone",
        field: "cciACCellPhone",
        type: "phoneNumber",
        className: "col-6",
      },
      { title: "Email", field: "cciCNEmail", type: "text", className: "col-6" },
      { title: "Email", field: "cciACEmail", type: "text", className: "col-6" },
    ],
  },
];
const schema = Yup.mixed().test("fileSize", "Please select a file", (file) => {
  return file?.length > 0;
});

const submitALoanFormSchema = Yup.object().shape({
  cciCompanyName: Yup.string().required("Company Name is mandatory"),
  cciCNContactName: Yup.string().required("Contact Name is mandatory"),
  cciCNCellPhone: Yup.string().required("Cell Phone is mandatory"),
  cciCNEmail: Yup.string().required("Email is mandatory"),
  cciSelectOne: Yup.string().required("Select One is mandatory"),
  biBorrowerOrCompanyName: Yup.string().required(
    "Borrower or Company Name is mandatory"
  ),
  biContactNameFirstLast: Yup.string().required(
    "Contact Name (First & Last) is mandatory"
  ),
  biMailingAddress: Yup.string().required("Mailing Address is mandatory"),
  biBorrowerEmail: Yup.string().required("Borrower Email is mandatory"),
  biCellPhone: Yup.string().required("Cell Phone is mandatory"),
  liInterestRate: Yup.string().required("Interest Rate is mandatory"),
  liSoldRate: Yup.string().required("Sold Rate is mandatory"),
  liLoanAmount: Yup.string().required("Loan Amount is mandatory"),
  liPaymentFrequency: Yup.string().required("Payment Frequency is mandatory"),
  liLoanPriority: Yup.string().required("Loan Priority is mandatory"),
  liInterestChargedOn: Yup.string().required(
    "Interest Charged on is mandatory"
  ),
  liCurrentUpb: Yup.string().required("Current UPB is mandatory"),
  liPropertyAddress: Yup.string().required("Property Address is mandatory"),
  liPropertyType: Yup.string().required("Property Type is mandatory"),
  liPropertyApn: Yup.string().required("Property APN is mandatory"),
  liInterestCalculation: Yup.string().required(
    "Interest Calculation is mandatory"
  ),
  liOccupancy: Yup.string().required("Occupancy is mandatory"),
  liLoanType: Yup.string().required("Loan Type is mandatory"),
  liServicePaidBy: Yup.string().required("Service Paid by is mandatory"),
  udNote: Yup.string()
    .required("Please enter some text")
    .test("wordLimit", "Maximum word limit exceeded (5000 Words)", (value) => {
      if (!value) return true; // Skip validation if the value is empty
      const words = value.trim().split(/\s+/);
      return words?.length <= 5000; // Maximum 5000 words
    }),
  udDeedOfTrustOrMortgage: schema,
  udFinalClosingStatement: schema,
  udEvidenceOfInsurance: schema,
  udCopiesOfTaxBillS: schema,
  udEstimatedEscrowAnalysis: schema,
});
export const submitALoanFormOptions = {
  resolver: yupResolver(submitALoanFormSchema),
};

const salGeneralSchema = Yup.object().shape({
  general_General_originalBalance: Yup.string().required(
    "Original Balance is mandatory"
  ),
  general_General_noteRate: Yup.string().required("Note Rate is mandatory"),
  general_General_soldRate: Yup.string().required("Sold Rate is mandatory"),
  general_General_priority: Yup.string().required("Priority is mandatory"),

  principalBalance: Yup.string().required("Principal Balance is mandatory"),
  unpaidLateCharges: Yup.string().required("Unpaid Late Charges is mandatory"),
  unpaidInterest: Yup.string().required("Unpaid Interest is mandatory"),

  P76_ACCRUALMETHOD: Yup.string().required("Accrual Method is mandatory"),

  P76_PMTFREQ: Yup.string().required("Frequency is mandatory"),
  P76_DUEDAY: Yup.string().required("Due Day is mandatory"),

  P76_CLOSINGDATE: Yup.date().required("Closing date is mandatory"),
  P76_FIRSTPAYMENTDATE: Yup.date().required("First Payment Date is mandatory"),
  P76_PURCHASEDATE: Yup.date().required("Purchase date is mandatory"),
  P76_BOOKINGDATE: Yup.date().required("Booking date is mandatory"),
  P76_NEXTDUEDATE: Yup.date().required("Next Payment date is mandatory"),
  P76_NEXTREVISION: Yup.date().required("Next Revision date is mandatory"),
  P76_MATURITYDATE: Yup.date().required("Maturity date is mandatory"),
  P76_PAIDOFFDATE: Yup.date().required("Paid Off date is mandatory"),

  P76_PMTPI: Yup.string().required("P & I selection is mandatory"),
  CurrentPIAmount: Yup.string().when("P76_PMTPI", {
    is: "CurrentPI",
    then: (schema) => schema.required("Current P & I Amount is mandatory"),
  }),
  FullyAmortizedToTermAmount: Yup.string().when("P76_PMTPI", {
    is: "FullyAmortizedToTerm",
    then: (schema) =>
      schema.required("Fully Amortized (To Term) Amount is mandatory"),
  }),
  FullyAmortized30YearsAmount: Yup.string().when("P76_PMTPI", {
    is: "FullyAmortized30Years",
    then: (schema) =>
      schema.required("Fully Amortized (30 years) Amount is mandatory"),
  }),
  FullyAmortized25YearsAmount: Yup.string().when("P76_PMTPI", {
    is: "FullyAmortized25Years",
    then: (schema) =>
      schema.required("Fully Amortized (25 years) Amount is mandatory"),
  }),
  FullyAmortized15YearsAmount: Yup.string().when("P76_PMTPI", {
    is: "FullyAmortized15Years",
    then: (schema) =>
      schema.required("Fully Amortized (15 years) Amount is mandatory"),
  }),
  InterestOnlyAmount: Yup.string().when("P76_PMTPI", {
    is: "InterestOnly",
    then: (schema) => schema.required("Interest Only Amount is mandatory"),
  }),
  ConstantAmortizationAmount: Yup.string().when("P76_PMTPI", {
    is: "ConstantAmortization",
    then: (schema) =>
      schema.required("Constant Amortization Amount is mandatory"),
  }),

  P76_PMTRESERVE: Yup.string().required("Reserve is mandatory"),
  P76_PMTIMPOUND: Yup.string().required("Impound is mandatory"),
});

export const salGeneralFormOptions = {
  resolver: yupResolver(salGeneralSchema),
};

export const salDetailsFormOptions = {
  resolver: yupResolver(
    Yup.object().shape({
      // Categories & Grouping section
      P76_COMPANY_ID: Yup.string().required("Company is mandatory"),
      P76_LOANOFFICER: Yup.string().required("Loan Officer is mandatory"),

      // Other Loan Details section
      P76_LOANPURPOSE: Yup.string().required("Loan Purpose is mandatory"),
      P76_DOCUMENTATION: Yup.string().required("Documentation is mandatory"),
      P76_FICO: Yup.string()
        .matches(/^\d+$/, "FICO Score must be a number")
        .required("FICO Score is mandatory"),

      P76_SECTION32: Yup.boolean(),
      P76_ARTICLE7: Yup.boolean(),
      P76_SECTION4970: Yup.boolean(),
      P76_RESPA: Yup.boolean(),
    })
  ),
};

export const updatedSALFormInputArr = [
  {
    field: "general",
    arr: [
      {
        section: "General",
        arr: [
          {
            title: "Original Balance",
            field: "general_General_originalBalance",
            type: "text",
            className: "col-12",
          },
          {
            title: "Note Rate",
            field: "general_General_noteRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Sold Rate",
            field: "general_General_soldRate",
            type: "text",
            className: "col-12",
          },
          {
            title: "Priority",
            field: "general_General_priority",
            type: "select",
            className: "col-12",
            options: [
              { label: "1st", value: "0" },
              { label: "2nd", value: "1" },
              { label: "3rd", value: "2" },
              { label: "4th", value: "3" },
              { label: "5th", value: "4" },
              { label: "6th", value: "5" },
              { label: "7th", value: "6" },
              { label: "8th", value: "7" },
              { label: "Other", value: "8" },
            ],
          },
        ],
      },
      {
        section: "Loan Balances",
        arr: [
          {
            title: "Principal Balance",
            type: "text",
            field: "principalBalance",
            className: "col-12",
          },
          {
            title: "Unpaid Late Charges",
            type: "text",
            field: "unpaidLateCharges",
            className: "col-12",
          },
          {
            title: "Unpaid Interest",
            type: "text",
            field: "unpaidInterest",
            className: "col-12",
          },
        ],
      },
      {
        section: "Unearned Discount / Fees",
        arr: [
          {
            title: "Accrual Method",
            field: "P76_ACCRUALMETHOD",
            type: "select",
            className: "col-12",
            options: [
              { label: "None", value: "0" },
              { label: "Discount Ratio", value: "1" },
              { label: "Remaining Term", value: "2" },
              { label: "At Maturity", value: "3" },
            ],
            defaultValue: "0",
          },
        ],
      },
      {
        section: "Payment Frequency",
        arr: [
          {
            title: "Frequency",
            field: "P76_PMTFREQ",
            type: "select",
            className: "col-12",
            options: [
              { label: "Once Only", value: "0" },
              { label: "Monthly", value: "1" },
              { label: "Yearly", value: "10" },
              { label: "Quartly", value: "2" },
              { label: "Bi-Monthly", value: "3" },
              { label: "Bi-Weekly", value: "4" },
              { label: "Weekly", value: "5" },
              { label: "Every 15 days", value: "6" },
              { label: "Twice A Month", value: "7" },
              { label: "15th & EOM", value: "8" },
              { label: "Semi Yearly", value: "9" },
            ],
          },
          {
            title: "Due Day",
            field: "P76_DUEDAY",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "Important Dates",
        arr: [
          {
            title: "Closing",
            field: "P76_CLOSINGDATE",
            type: "date",
            className: "col-12",
          },
          {
            title: "First Payment Date",
            field: "P76_FIRSTPAYMENTDATE",
            type: "date",
            className: "col-12",
          },
          {
            title: "Purchase",
            field: "P76_PURCHASEDATE",
            type: "date",
            className: "col-12",
          },
          {
            title: "Booking",
            field: "P76_BOOKINGDATE",
            type: "date",
            className: "col-12",
          },
          {
            title: "Next Payment",
            field: "P76_NEXTDUEDATE",
            type: "date",
            className: "col-12",
          },
          {
            title: "Next Revision",
            field: "P76_NEXTREVISION",
            type: "date",
            className: "col-12",
          },
          {
            title: "Maturity",
            field: "P76_MATURITYDATE",
            type: "date",
            className: "col-12",
          },
          {
            title: "Paid Off",
            field: "P76_PAIDOFFDATE",
            type: "date",
            className: "col-12",
          },
        ],
      },
      {
        section: "Regular Payment",
        arr: [
          {
            title: "P & I",
            field: "P76_PMTPI",
            type: "pencil",
            className: "col-12",
            popupTitle: "Calculate P & I",
          },
          // {
          //   title: "P & I",
          //   field: "P76_PMTPI",
          //   type: "select",
          //   className: "col-12",
          //   options: [
          //     { label: "Current P & I", value: "CurrentPI" },
          //     {
          //       label: "Fully Amortized (To Term)",
          //       value: "FullyAmortizedToTerm",
          //     },
          //     {
          //       label: "Fully Amortized (30 years)",
          //       value: "FullyAmortized30Years",
          //     },
          //     {
          //       label: "Fully Amortized (25 years)",
          //       value: "FullyAmortized25Years",
          //     },
          //     {
          //       label: "Fully Amortized (15 years)",
          //       value: "FullyAmortized15Years",
          //     },
          //     { label: "Interest Only", value: "InterestOnly" },
          //     { label: "Constant Amortization", value: "ConstantAmortization" },
          //   ],
          // },
          // {
          //   title: "Current P & I",
          //   field: "CurrentPIAmount",
          //   type: "text",
          //   defaultValue: "",
          //   dependsOn: [
          //     {
          //       field: "P76_PMTPI",
          //       value: "CurrentPI",
          //     },
          //   ],
          // },
          // {
          //   title: "Fully Amortized (To Term)",
          //   field: "FullyAmortizedToTermAmount",
          //   type: "text",
          //   defaultValue: "",
          //   dependsOn: [
          //     {
          //       field: "P76_PMTPI",
          //       value: "FullyAmortizedToTerm",
          //     },
          //   ],
          // },
          // {
          //   title: "Fully Amortized (30 years)",
          //   field: "FullyAmortized30YearsAmount",
          //   type: "text",
          //   defaultValue: "",
          //   dependsOn: [
          //     {
          //       field: "P76_PMTPI",
          //       value: "FullyAmortized30Years",
          //     },
          //   ],
          // },
          // {
          //   title: "Fully Amortized (25 years)",
          //   field: "FullyAmortized25YearsAmount",
          //   type: "text",
          //   defaultValue: "",
          //   dependsOn: [
          //     {
          //       field: "P76_PMTPI",
          //       value: "FullyAmortized25Years",
          //     },
          //   ],
          // },
          // {
          //   title: "Fully Amortized (15 years)",
          //   field: "FullyAmortized15YearsAmount",
          //   type: "text",
          //   defaultValue: "",
          //   dependsOn: [
          //     {
          //       field: "P76_PMTPI",
          //       value: "FullyAmortized15Years",
          //     },
          //   ],
          // },
          // {
          //   title: "Interest Only",
          //   field: "InterestOnlyAmount",
          //   type: "text",
          //   defaultValue: "",
          //   dependsOn: [
          //     {
          //       field: "P76_PMTPI",
          //       value: "InterestOnly",
          //     },
          //   ],
          // },
          // {
          //   title: "Constant Amortization",
          //   field: "ConstantAmortizationAmount",
          //   type: "text",
          //   defaultValue: "",
          //   dependsOn: [
          //     {
          //       field: "P76_PMTPI",
          //       value: "ConstantAmortization",
          //     },
          //   ],
          // },
          {
            title: "Reserve",
            field: "P76_PMTRESERVE",
            type: "text",
            className: "col-12",
          },
          {
            title: "Impound",
            field: "P76_PMTIMPOUND",
            type: "text",
            className: "col-12",
          },
        ],
      },
    ],
  },
  {
    field: "details",
    arr: [
      {
        section: "Categories & Grouping",
        arr: [
          {
            title: "Company",
            field: "P76_COMPANY_ID",
            type: "select",
            className: "col-12",
            options: [
              { value: "1", label: "SUPERIOR LOAN SERVICING" },
              { value: "2", label: "HDB Financial Services Limited" },
            ],
            defaultValue: "1",
          },
          // {
          //   title: "Loan Code",
          //   field: "P76_LOANCODE",
          //   type: "text",
          //   className: "col-12",
          // },
          {
            title: "Loan Officer",
            field: "P76_LOANOFFICER",
            type: "text",
            className: "col-12",
          },
          // {
          //   title: "Categories",
          //   field: "P76_CATEGORIES",
          //   type: "textarea",
          //   className: "col-12",
          // },
        ],
      },
      // {
      //   section: "Escrow Analysis",
      //   arr: [
      //     {
      //       title: "Next Computation Period",
      //       field: "P76_ESCROWSTATEMENTNEXT",
      //       type: "date",
      //       className: "col-12",
      //     },
      //   ],
      // },
      {
        section: "Other Loan Details",
        arr: [
          {
            title: "Loan Purpose",
            field: "P76_LOANPURPOSE",
            type: "select",
            className: "col-12",
            options: [
              {
                value: "CashOutDebtConsolidation",
                label: "Cash Out/Debt Consolidation",
              },
              {
                value: "CashOutHomeImprovement",
                label: "Cash Out/Home Improvement",
              },
              { value: "CashOutOther", label: "Cash Out/Other" },
              {
                value: "LimitedCashOutRateAndTerm",
                label: "Limited Cash Out/Rate & Term",
              },
              { value: "CashOutRefi", label: "Cash-Out Refi" },
              { value: "Construction", label: "Construction" },
              { value: "ConstructionPerm", label: "Construction-Perm" },
              { value: "DebtConsolidation", label: "Debt Consolidation" },
              { value: "HomeImprovement", label: "Home Improvement" },
              { value: "NoCashOutRefi", label: "No Cash-Out Refi" },
              { value: "Other", label: "Other" },
              { value: "Purchase", label: "Purchase" },
            ],
          },
          {
            title: "Documentation",
            field: "P76_DOCUMENTATION",
            type: "select",
            className: "col-12",
            options: [
              { value: "Alternate", label: "Alternate" },
              { value: "Full", label: "Full" },
              { value: "Stated", label: "Stated" },
            ],
          },
          {
            title: "FICO Score",
            field: "P76_FICO",
            type: "text",
            className: "col-12",
          },
          {
            title: "Section 32",
            field: "P76_SECTION32",
            type: "checkbox",
            className: "col-6",
          },
          {
            title: "Article 7",
            field: "P76_ARTICLE7",
            type: "checkbox",
            className: "col-6",
          },
          {
            title: "Section 4970",
            field: "P76_SECTION4970",
            type: "checkbox",
            className: "col-6",
          },
          {
            title: "RESPA",
            field: "P76_RESPA",
            type: "checkbox",
            className: "col-6",
          },
        ],
      },
      // {
      //   section: "Tax Reporting Information",
      //   arr: [
      //     {
      //       title: "IRS 1098 Points Paid",
      //       field: "P76_SEND1098",
      //       type: "text",
      //       className: "col-12",
      //     },
      //   ],
      // },
    ],
  },
  {
    field: "commercials",
    arr: [
      {
        section: "Commercial",
        arr: [],
      },
    ],
  },
  {
    field: "construction",
    arr: [
      {
        section: "Construction",
        subArr: [
          {
            subArrtitle: "Project",
            subArrarr: [
              {
                section: "General",
                arr: [
                  {
                    title: "Property Address",
                    field: "PropertyAddress",
                    type: "textarea",
                    className: "col-12",
                  },
                  // {
                  //   title: "Project Sq. Ft.",
                  //   field: "projectSqFt",
                  //   type: "text",
                  //   className: "col-6",
                  // },
                  // {
                  //   title: "Joint Check",
                  //   field: "jointCheck",
                  //   type: "checkbox",
                  //   className: "col-6",
                  // },
                  // {
                  //   title: "Completion Date",
                  //   field: "completionDate",
                  //   type: "date",
                  //   className: "col-6",
                  // },
                  // {
                  //   title: "Revolving",
                  //   field: "revolving",
                  //   type: "checkbox",
                  //   className: "col-6",
                  // },
                ],
              },
              // {
              //   section: "Funding",
              //   arr: [
              //     {
              //       title: "Available Fund",
              //       type: "text",
              //       field: "availableFund",
              //       className: "col-12",
              //     },
              //   ],
              // },
              {
                section: "Contractor Information",
                arr: [
                  {
                    title: "Name & Address",
                    type: "textarea",
                    field: "nameAndAddress",
                    className: "col-12",
                  },
                  {
                    title: "License No.",
                    type: "text",
                    field: "licenseNo",
                    className: "col-12",
                  },
                ],
              },
              {
                section: "Tasks",
                arr: [],
              },
            ],
          },
          {
            subArrtitle: "Billing",
            subArrarr: [
              {
                section: "",
                arr: [
                  {
                    title: "Loc Usemaintenancefee",
                    field: "LocUsemaintenancefee",
                    type: "text",
                    className: "col-12",
                  },
                  {
                    title: "Loc Calculationmethod",
                    field: "LocCalculationmethod",
                    type: "text",
                    className: "col-12",
                  },
                  {
                    title: "Loc Earlyclosureamount",
                    field: "LocEarlyclosureamount",
                    type: "text",
                    className: "col-12",
                  },
                  {
                    title: "Loc Payamountmethod",
                    field: "LocPayamountmethod",
                    type: "text",
                    className: "col-12",
                  },
                  {
                    title: "Loc Payamountvalue",
                    field: "LocPayamountvalue",
                    type: "text",
                    className: "col-12",
                  },
                ],
              },
              {
                section: "Billing Cycle",
                arr: [
                  {
                    title: "Billing Frequency",
                    type: "text",
                    field: "BillingFrequency",
                    className: "col-12",
                  },
                  {
                    title: "Loc Billedtodate",
                    type: "date",
                    field: "LocBilledtodate",
                    className: "col-12",
                  },
                  {
                    title: "Start Day",
                    type: "text",
                    field: "StartDay",
                    className: "col-12",
                  },
                ],
              },
              {
                section: "Account Maintenance Fee",
                arr: [
                  {
                    title: "Maintenance Fee",
                    type: "text",
                    field: "MaintenanceFee",
                    className: "col-12",
                  },
                  {
                    title: "Frequency",
                    type: "text",
                    field: "Frequency",
                    className: "col-12",
                  },
                  {
                    title: "Next Charge Date",
                    type: "date",
                    field: "NextChargeDate",
                    className: "col-12",
                  },
                ],
              },
              {
                section: "Interest Charge Calculation",
                arr: [
                  {
                    title: "Exclude Late Charges/NSFa",
                    type: "text",
                    field: "ExcludeLateCharges/NSFa",
                    className: "col-12",
                  },
                  {
                    title: "Exclude Reserve Balances",
                    type: "date",
                    field: "ExcludeReserveBalances",
                    className: "col-12",
                  },
                  {
                    title: "Exclude Impound Balances",
                    type: "text",
                    field: "ExcludeImpoundBalances",
                    className: "col-12",
                  },
                  {
                    title: "Exclude Finance Charges",
                    type: "text",
                    field: "ExcludeFinanceCharges",
                    className: "col-12",
                  },
                ],
              },
              {
                section: "Last Billing Statement",
                arr: [],
              },
              {
                section: "Funding Transaction Fee",
                arr: [],
              },
              {
                section: "Auto Payment from Reserve",
                arr: [],
              },
              {
                section: "Interest on Available Fund",
                arr: [],
              },
            ],
          },
          {
            subArrtitle: "Vouchers",
            subArrarr: [],
          },
          {
            subArrtitle: "Inspection",
            subArrarr: [],
          },
        ],
      },
    ],
  },
  // {
  //   field: "lineOfCredit",
  //   arr: [
  //     {
  //       section: "Line Of Credit",
  //       arr: [],
  //     },
  //   ],
  // },
  {
    field: "arm",
    arr: [
      {
        section: "ARM",
        arr: [
          {
            title: "Arm Indexrecid",
            field: "P76_ARM_INDEXRECID",
            type: "text",
            className: "col-12",
          },
          {
            title: "Index",
            field: "P76_ARM_INDEX",
            type: "select",
            className: "col-12",
            options: [
              { value: "None", label: "None" },
              {
                value: "SecuredOvernightFinancingRate30DayAvg",
                label: "Secured Overnight Financing Rate (30 Day Avg)",
              },
              {
                value: "SecuredOvernightFinancingRateSOFR",
                label: "Secured Overnight Financing Rate (SOFR)",
              },
              { value: "USDLIBOR1Month", label: "USD LIBOR - 1 month" },
              { value: "WSJPrimeRate", label: "WSJ Prime Rate" },
            ],
          },
          {
            title: "Margin",
            field: "P76_ARM_MARGIN",
            type: "text",
            className: "col-12",
          },
          {
            title: "Ceiling",
            field: "P76_ARM_CEILING",
            type: "text",
            className: "col-12",
          },
          {
            title: "Floor",
            field: "P76_ARM_FLOOR",
            type: "text",
            className: "col-12",
          },
          {
            title: "Arm Ratefirstchgactive",
            field: "P76_ARM_RATEFIRSTCHGACTIVE",
            type: "text",
            className: "col-12",
          },
          {
            title: "First Change Min Cap",
            field: "P76_ARM_RATEFIRSTCHGMINCAP",
            type: "text",
            className: "col-12",
          },
          {
            title: "First Change Max Cap",
            field: "P76_ARM_RATEFIRSTCHGMAXCAP",
            type: "text",
            className: "col-12",
          },
          {
            title: "Arm Rateperiodicmincap",
            field: "P76_ARM_RATEPERIODICMINCAP",
            type: "text",
            className: "col-12",
          },
          {
            title: "Arm Rateperiodicmaxcap",
            field: "P76_ARM_RATEPERIODICMAXCAP",
            type: "text",
            className: "col-12",
          },
          {
            title: "Adjustment Freq",
            field: "P76_ARM_RATECHANGEFREQ",
            type: "text",
            className: "col-12",
          },
          {
            title: "Next Rate Change",
            field: "P76_ARM_RATECHANGENEXT",
            type: "date",
            className: "col-12",
          },
          {
            title: "Rounding Method",
            field: "P76_ARM_RATEROUNDING",
            type: "text",
            className: "col-12",
          },
          {
            title: "Arm Rateroundfactor",
            field: "P76_ARM_RATEROUNDFACTOR",
            type: "text",
            className: "col-12",
          },
          {
            title: "Send Change Notice",
            field: "P76_ARM_SENDRATECHANGENOTICE",
            type: "text",
            className: "col-12",
          },
          {
            title: "Notice Leas Days",
            field: "P76_ARM_NOTICELEADDAYS",
            type: "text",
            className: "col-12",
          },
          {
            title: "Arm Carryoverenabled",
            field: "P76_ARM_CARRYOVERENABLED",
            type: "text",
            className: "col-12",
          },
          {
            title: "Carryover",
            field: "P76_ARM_CARRYOVERAMOUNT",
            type: "text",
            className: "col-12",
          },
          {
            title: "Look Back Days",
            field: "P76_ARM_LOOKBACKDAYS",
            type: "text",
            className: "col-12",
          },
          {
            title: "Arm Paymentadjustment",
            field: "P76_ARM_PAYMENTADJUSTMENT",
            type: "text",
            className: "col-12",
          },
          {
            title: "Payment Cap",
            field: "P76_ARM_PAYMENTCAP",
            type: "text",
            className: "col-12",
          },
          {
            title: "Arm Paymentchangefreq",
            field: "P76_ARM_PAYMENTCHANGEFREQ",
            type: "text",
            className: "col-12",
          },
          {
            title: "Arm Paymentchangenext",
            field: "P76_ARM_PAYMENTCHANGENEXT",
            type: "date",
            className: "col-12",
          },
          {
            title: "Neg  Amort Cap",
            field: "P76_ARM_NEGAMORTCAP",
            type: "text",
            className: "col-12",
          },
          {
            title: "Recast Payment",
            field: "P76_ARM_RECASTPAYMENT",
            type: "text",
            className: "col-12",
          },
          {
            title: "Arm Recastfreq",
            field: "P76_ARM_RECASTFREQ",
            type: "text",
            className: "col-12",
          },
          {
            title: "Recast Next Date",
            field: "P76_ARM_RECASTNEXTDATE",
            type: "date",
            className: "col-12",
          },
          {
            title: "Recast Stop Date",
            field: "P76_ARM_RECASTSTOPDATE",
            type: "date",
            className: "col-12",
          },
          {
            title: "Arm Recasttodate",
            field: "P76_ARM_RECASTSTOPDATE",
            type: "date",
            className: "col-12",
          },
          {
            title: "Arm Userecasttodate",
            field: "P76_ARM_RECASTSTOPDATE",
            type: "text",
            className: "col-12",
          },
          {
            title: "Arm Isoptionarm",
            field: "P76_ARM_RECASTSTOPDATE",
            type: "text",
            className: "col-12",
          },
          {
            title: "First Notice Sent",
            field: "P76_ARM_RECASTSTOPDATE",
            type: "date",
            className: "col-12",
          },
        ],
      },
    ],
  },
  {
    field: "gtm",
    arr: [
      {
        section: "GTM",
        arr: [],
      },
    ],
  },
  {
    field: "penalties",
    arr: [
      {
        section: "Penalties",
        arr: [
          {
            title: "Late charge",
            field: "P76_LATECHGMETHOD",
            type: "text",
            className: "col-12",
            defaultValue: "Default",
          },
          {
            title: "Number of Grace Days",
            field: "P76_LATECHGDAYS",
            type: "text",
            className: "col-12",
          },
          {
            title: "Minimum Late Charge",
            field: "P76_LATECHGMIN",
            type: "text",
            className: "col-12",
          },
          {
            title: "Latechgpct",
            field: "P76_LATECHGPCT",
            type: "text",
            className: "col-12",
          },
          {
            title: "Distribute to Lenders",
            field: "P76_LATECHGLENDERPCT",
            type: "text",
            className: "col-12",
          },
          {
            title: "Distribute to Orig. Vendor",
            field: "P76_LATECHGVENDORPCT",
            type: "text",
            className: "col-12",
          },
          // {
          //   title: "Latechgdaily",
          //   field: "P76_LATECHGDAILY",
          //   type: "text",
          //   className: "col-12",
          // },
          {
            title: "Defaultrateuse",
            field: "P76_DEFAULTRATEUSE",
            type: "text",
            className: "col-12",
          },
          {
            title: "Defaultrateafterperiod",
            field: "P76_DEFAULTRATEAFTERPERIOD",
            type: "text",
            className: "col-12",
          },
          {
            title: "Default After",
            field: "P76_DEFAULTRATEAFTERVALUE",
            type: "text",
            className: "col-12",
          },
          {
            title: "Default Effective Until",
            field: "P76_DEFAULTRATEUNTIL",
            type: "text",
            className: "col-12",
          },
          {
            title: "Default Rate Method",
            field: "P76_DEFAULTRATEMETHOD",
            type: "text",
            className: "col-12",
          },
          {
            title: "Default Rate Value",
            field: "P76_DEFAULTRATEVALUE",
            type: "text",
            className: "col-12",
          },
          {
            title: "Distribute to Lenders",
            field: "P76_DEFAULTRATELENDERPCT",
            type: "text",
            className: "col-12",
          },
          {
            title: "Distribute to Orig. Vendor",
            field: "P76_DEFAULTRATEVENDORPCT",
            type: "text",
            className: "col-12",
          },
          {
            title: "Distribute to Company",
            field: "P76_DistributetoCompany",
            type: "text",
            className: "col-12",
          },
        ],
      },
    ],
  },
  {
    field: "escrowVouchers",
    arr: [
      {
        section: "Escrow Vouchers",
        arr: [],
      },
    ],
  },
  {
    field: "options",
    arr: [
      {
        section: "Escrow Vouchers",
        className: "col-12",
        arr: [
          {
            title: "Loantype",
            field: "loantype",
            type: "select",
            className: "col-12",
            options: [
              { value: "Other", label: "Other" },
              { value: "Commercial", label: "Commercial" },
              { value: "Construction", label: "Construction" },
            ],
            defaultValue: "Other",
          },
          {
            title: "Amortization Type",
            field: "amorttype",
            type: "select",
            className: "col-12",
            options: [
              { value: "Other", label: "Other" },
              { value: "FAMFullyAmortized", label: "FAM-Fully Amortized" },
              {
                value: "PAMPartiallyAmortized",
                label: "PAM-Partially Amortized",
              },
              { value: "IOMInterestOnly", label: "IOM-Interest Only" },
              {
                value: "CAMConstantAmortization",
                label: "CAM-Constant Amortization",
              },
              { value: "ADDAddOnInterest", label: "ADD-Add-On Interest" },
            ],
          },
          {
            title: "Rate Type",
            field: "ratetype",
            type: "select",
            className: "col-12",
            options: [
              { value: "360DayYearBasis", label: "360 Day Year Basis" },
              { value: "365DayYearBasis", label: "365 Day Year Basis" },
              { value: "30DayMonthBasis", label: "30 Day Month Basis" },
              { value: "ActualNumberOfDays", label: "Actual Number of Days" },
            ],
          },
        ],
      },
    ],
  },
];

export const lenderAccountSetupArr = [
  {
    field: "general",
    arr: [
      {
        section: "Lender Information",
        arr: [
          {
            title: "Contact Name",
            field: "contact_name",
            type: "text",
            className: "col-12",
          },
          {
            title: "Vesting / Company Name",
            field: "Vesting_Company_Name",
            type: "text",
            className: "col-12",
          },
          {
            title: "Lender Type",
            field: "lender_type",
            className: "col-12",
            type: "radio",
            options: [
              {
                title: "Direct Lender/Originator",
                value: "direct_lender_Originator",
              },
              { title: "Broker", value: "Broker" },
              { title: "Institutional Fund", value: "institutional_fund" },
              { title: "Loan Aggregator", value: "loan_aggregator" },
              { title: "Other", value: "Other" },
            ],
          },
          {
            title: "Mailing Address",
            field: "mailing_address",
            type: "text",
            className: "col-12",
          },
          {
            title: "City",
            field: "City",
            type: "text",
            className: "col-4",
          },
          {
            title: "State",
            field: "State",
            type: "text",
            className: "col-4",
          },
          {
            title: "Zip",
            field: "Zip",
            type: "text",
            className: "col-4",
          },
          {
            title: "Home Phone",
            field: "home_phone",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Work Phone",
            field: "work_phone",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Cell Phone",
            field: "cell_phone",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Email Address",
            field: "email_address",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section:
          "If vesting is an IRA, please provide company information below:",
        arr: [
          {
            title: "Vesting / Company Name",
            field: "Vesting_Company_Name1",
            type: "text",
            className: "col-12",
          },
          {
            title: "IRA Account Number",
            type: "text",
            field: "IRA_Account_Number",
            className: "col-12",
          },
          {
            title: "IRA Address",
            type: "textarea",
            field: "IRA_Address",
            className: "col-12",
          },
          {
            title: "City",
            field: "City1",
            type: "text",
            className: "col-12",
          },
          {
            title: "State",
            field: "State1",
            type: "text",
            className: "col-12",
          },
          {
            title: "Zip",
            field: "Zip1",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section:
          "Banking Account Information (Bank accounts must be titled exactly as your account with SLS).",
        arr: [
          {
            title: "Account Name(s)",
            field: "Account_Name(s)",
            type: "text",
            className: "col-12",
          },
          {
            title: "Bank Name",
            type: "text",
            field: "Bank_Name1",
            className: "col-12",
          },
          {
            title: "Account Type",
            field: "Account_Type1",
            className: "col-12",
            type: "radio",
            options: [
              { title: "Checking", value: "Checking" },
              { title: "Savings", value: "Savings" },
            ],
          },
          {
            title: "Bank Address",
            type: "textarea",
            field: "Bank_Address1",
            className: "col-12",
          },
          {
            title: "City",
            field: "City2",
            type: "text",
            className: "col-4",
          },
          {
            title: "State",
            field: "State2",
            type: "text",
            className: "col-4",
          },
          {
            title: "Zip",
            field: "Zip2",
            type: "text",
            className: "col-4",
          },
          {
            title: "Routing Number",
            field: "Routing_Number2",
            type: "text",
            className: "col-6",
          },
          {
            title: "Account Number",
            field: "Account_Number2",
            type: "text",
            className: "col-6",
          },
        ],
      },
      {
        section:
          "1 (We) authorize SLS to initiate ACH transactions to my/our account indicated in accordance with the provisions of U.S law:",
        arr: [
          {
            title: "Print Name",
            field: "Print_Name1",
            type: "text",
            className: "col-12",
          },
          {
            title: "Signature",
            field: "Signature1",
            type: "text",
            className: "col-12",
          },
          {
            title: "Print Name",
            field: "Print_Name2",
            type: "text",
            className: "col-12",
          },
          {
            title: "Signature",
            field: "Signature2",
            type: "text",
            className: "col-12",
          },
        ],
      },
    ],
  },
];

export const lenderAccountSetupArrContinued = [
  {
    field: "general",
    arr: [
      {
        section: "",
        arr: [
          {
            title: "What is the size of your fund? (Dollar Amount)",
            field: "what_is_the_size_of_your_fund?",
            type: "text",
            className: "col-12",
          },
          {
            title:
              "What is the expected loan volume by amount to be serviced annually?",
            field:
              "what_is_the_expected_loan_volume_by_amount_to_be_serviced_annually?",
            type: "text",
            className: "col-12",
          },
          {
            title:
              "What type of loans are you are requiring servicing? (Fix and Flip, Contruction, Bridge, Rehab, etc.)",
            field: "what_type_of_loans_are_you_are_requiring_servicing?",
            type: "text",
            className: "col-12",
          },
          {
            title: "Are we transferring loans from another servicer?",
            field: "are_we_transferring_loans_from_another_servicer?",
            type: "text",
            className: "col-12",
          },
          {
            title:
              "Please provide us a list of requirements to service your loans",
            field:
              "please_provide_us_a_list_of_requirements_to_service_your_loans",
            type: "textarea",
            className: "col-12",
          },
          {
            title:
              "Are there any terms on your loan that is not addressed in the Note?",
            field:
              "are_there_any_terms_on_your_loan_that_is_not_addressed_in_the_Note?",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "What is the typical distribution flow?",
            field: "what_is_the_typical_distribution_flow?",
            type: "textarea",
            className: "col-12",
          },
          {
            title:
              "Who is the main contact person for loan extensions or modifications? (Please provide name, email, and phone)",
            field:
              "who_is_the_main_contact_person_for_loan_extensions_or_modifications?",
            type: "textarea",
            className: "col-12",
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            title: "Who will be preparing the extensions or loan modifications",
            field: "who_will_be_preparing_the_extensions_or_loan_modifications",
            type: "textarea",
            className: "col-12",
          },
          {
            title:
              "If SLS is preparing the extension or loan modification, do you have standard terms that should be listed?",
            field:
              "if_SLS_is_preparing_the_extension_or_loan_modification_do_you_have_standard_terms_that_should_be_listed?",
            type: "textarea",
            className: "col-12",
          },
          {
            title:
              "In the event of a default, who is the primary contact person for foreclosures?",
            field:
              "in_the_event_of_a_default_who_is_the_primary_contact_person_for_foreclosures?",
            type: "textarea",
            className: "col-12",
          },
          {
            title:
              "Who should handle foreclosures(SLS/ADM, lender, or 3rd party)?",
            field: "who_should_handle_foreclosures?",
            type: "textarea",
            className: "col-12",
          },
          {
            title:
              "Who is the main contract person for demands and lien releases? (Please include name, email and phone)",
            field:
              "who_is_the_main_contract_person_for_demands_and_lien_releases?",
            type: "textarea",
            className: "col-12",
          },
          {
            title:
              "Who will be reviewing and approving payoff demand statements",
            field:
              "who_will_be_reviewing_and_approving_payoff_demand_statements",
            type: "textarea",
            className: "col-12",
          },
          {
            title:
              "Who can provide recorded trailing docs? (UCC, Mortgage/building, assignment of leases and rents, assignment of contracts)? (Please include name, email, and phone)",
            field: "who_can_provide_recorded_trailing_docs?",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "Is Docusign for Payoff Demand approval accepted?",
            field: "is_docusign_for_payoff_demand_approval_accepted?",
            type: "text",
            className: "col-12",
          },
        ],
      },
    ],
  },
];
